import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as WorkingPartServices from "../../../../services/WorkingPartService";
import * as CodeService from "../../../../services/CodeService";
import * as TaskService from "../../../../services/TaskService";

import { useTranslation } from "react-i18next";
import DailyPartDetail from "./workingPartDetail.view";
import PATHS from "../../../../constants/paths";
import {
  STATUS_PART_VALIDATED,
  STATUS_PART_CONFIRMED,
} from "../../../../constants/index";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";
import { useDailyPart } from "../hook/useDailyPart";

const DailyPartDetailContainer = ({ isTechnical, uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [dailyPart, setDailyPart] = useState(null);
  const [isValidate, setIsValidate] = useState(true);
  const [isConfirmed, setIsConfirmed] = useState(true);
  // const [rows, setRows] = useState(0);

  const loadData = useCallback(async () => {
    if (uuid) {
      const result = await WorkingPartServices.getDailyPart(uuid);
      if (result) {
        setIsValidate(result.status === STATUS_PART_VALIDATED.code);
        setIsConfirmed(result.status === STATUS_PART_CONFIRMED.code);
        setDailyPart(result);
      }
    }
  }, [uuid]);

  const {
    updatePart,
    deletePart,
    createPart,
    validateDailyPart,
    confirmDailyPart,
  } = useDailyPart(loadData);

  useEffect(() => {
    loadData();
  }, []);

  const handlerPartUpdate = async (part) => {
    await updatePart(true, part.uuid);
  };

  const handlerPartDelete = async (part) => {
    await deletePart(true, part.uuid);
  };

  const handlerPartCreate = async () => {
    createPart(true, dailyPart.uuid);
  };

  const handlerPartOnBack = async () => {
    if (isTechnical) {
      navigate(PATHS.MY_WORKING_PART_LIST);
    } else {
      navigate(PATHS.WORKING_PART_LIST);
    }
  };

  const handlerPartValidate = async () => {
    try {
      await validateDailyPart(dailyPart.uuid);
    } catch (error) {}
  };

  const handlerPartConfirm = async () => {
    try {
      await confirmDailyPart(dailyPart.uuid);
    } catch (error) {}
  };

  return (
    <DailyPartDetail
      isTechnical={isTechnical}
      isConfirmed={isConfirmed}
      isValidate={isValidate}
      dailyPart={dailyPart}
      onDeletePart={handlerPartDelete}
      onUpdatePart={handlerPartUpdate}
      onCreatePart={handlerPartCreate}
      onBack={handlerPartOnBack}
      validatePart={handlerPartValidate}
      confirmPart={handlerPartConfirm}
    />
  );
};

DailyPartDetailContainer.propTypes = {
  t: PropTypes.any,
};

export default DailyPartDetailContainer;
